<div class="div_loading noprint">
  <div class="my-container" [hidden]="!loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div mat-dialog-title class="matDialogTitle noprint">
  <span> فاکتور {{ code_factor }} </span>
  <span class="close" (click)="close()">
    <mat-icon>close</mat-icon>
  </span>
</div>

<div class="matDialogContent print" style="max-height: 89vh;">
  <div class='container-fluit pish-factor allhome pishfactorall print' id='pre_factor'>
    <div class='row f_row' style='margin-top:20px !important;margin-bottom:0px !important'>
      <div class='col-md-12'>
        <table class='fa_table1'>
          <tr>
            <td style='width:25%;padding-right:13px'>
              <img src='https://hooshmandsazeh.com/object/images/logohoshfa.png' id="logo"
                [hidden]="tax_check_value == 1">
            </td>
            <td style='text-align:center;width:50%;font-size:16px'>
              <span *ngIf="product == 1 ">مونتاژ و نصب</span>
              <span *ngIf="product == 2">دمونتاژ</span>
              <span *ngIf="product == 3">طراحی</span>
              <span *ngIf="product ==4">نورد پروفیل</span>
            </td>
            <td style='width:25%;font-size: 0.7rem;'>
              <p>
                <span style='float:right'>تاریخ : </span>
                <span style='float:right'>{{ date }}</span>
              </p><br>
              <p style="text-align: right;">
                <span>شماره پیش فاکتور :</span>
                <span *ngIf='code >= 2'>شماره پیش فاکتور تایید شده:</span>
                <span id='code_factor'>{{ code_factor }}</span>

              </p>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class='row f_row'>
      <div class='col-md-12'>
        <div class='col-md-12' style='text-align:right;font-family:irsans;font-size: 0.7rem;'>
          <span> خریدار :</span>
          <span id='name_factor'>{{ user_title }}</span>
          <span style='margin-right:36px'> شماره همراه : </span>
          <span id='cellphone_factor'>{{ cellphone }}</span>
        </div>
      </div>
    </div>

    <div class='row' style='width:100% !important'>
      <div class='col-md-12 pishfactor-table'>
        <table class='table table2 f_table1'>
          <tr class='factor-tr'>
            <th style='border:solid 1px #ccc;'> کل طبقات ساختمان </th>
            <th style='border:solid 1px #ccc;'>زیر بنای کل <br>m<sup>2</sup></th>
            <th style='border:solid 1px #ccc;' [hidden]='true'>وزن کل تقریبی سازه مونتاژ<br>kg</th>
            <th style='border:solid 1px #ccc;' *ngIf="product == 1 || product == 4 || product == 2">قیمت کل
              سازه درب کارخانه<br>تومان</th>
            <th style='border:solid 1px #ccc;'>قیمت کل طراحی سازه<br>تومان</th>
            <th style='border:solid 1px #ccc;' *ngIf="product == 1 || product == 4 || product == 2">هزینه
              پیچ<br>تومان</th>
            <th style='border:solid 1px #ccc;'>هزینه طراحی معماری فاز 1<br>به تومان</th>
            <th style='border:solid 1px #ccc;' *ngIf="product == 3">هزینه طراحی معماری فاز 2<br>به تومان
            </th>

            <th style='border:solid 1px #ccc;' [hidden]='true'>هزینه طراحی معماری فاز 2<br>به تومان</th>
            <th style='border:solid 1px #ccc;' *ngIf="product == 1 || product == 4 || product == 2">
              ضایعات<br>به تومان</th>
          </tr>
          <tr>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'><span id='floor_factor'>{{ floor_title
                }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'><span id='bana_all_factor'>{{ bana_all |
                number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' [hidden]='true'><span id='mw_factor'>{{ mv
                | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'
              *ngIf="product == 1 || product == 4 || product == 2"><span id='mwf_factor'>{{ mwf | number }}</span>
            </td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'><span id='design_all_factor'>{{ design_all
                | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'
              *ngIf="product == 1 || product == 4 || product == 2"><span id='price_lsf_factor'>{{ price_lsf | number
                }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'><span id='arch1_factor'>{{ arch1 | number
                }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' *ngIf="product == 3"><span id='arch2_factor'>{{
                arch2 | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'
              *ngIf="product == 1 || product == 4 || product == 2"><span id='hard_factor'>{{ wast | number }}</span>
            </td>
          </tr>
        </table>


        <table class='table table2 f_table1'>
          <tr class='factor-tr'>
            <th style='border:solid 1px #ccc;width:9%' *ngIf="product == 1 || product == 4"> هزینه کل نصب<br>تومان
            </th>
            <th style='border:solid 1px #ccc;width:9%' *ngIf="product==1 || product == 4"> هزینه نصب به
              m<sup>2</sup> به تومان </th>
            <th style='border:solid 1px #ccc;width:9%' *ngIf="product==1 || product == 4 || product == 2"> هزینه
              سازه به m<sup>2</sup> به تومان </th>

            <th style='border:solid 1px #ccc;width:9%' *ngIf="product==1 || product == 4 || product == 2"> قیمت کل
              به متر مربع به تومان</th>
            <th style='border:solid 1px #ccc;width:9%'> قیمت کل به تومان </th>
            <th style='border:solid 1px #ccc;width:9%' [hidden]="discount_all == 0"> تخفیف به تومان
            </th>
            <th style='border:solid 1px #ccc;width:9%' [hidden]="discount == 0 || true"> تخفیف مدیریتی به تومان </th>
            <th style='border:solid 1px #ccc;width:9%' *ngIf="product==1 || product == 4 || product == 2"
              [hidden]="discount == 0"> قیمت کل
              به m<sup>2</sup> به تومان </th>
            <th style='border:solid 1px #ccc;width:9%' [hidden]="discount == 0"> قیمت کل با تخفیف به تومان </th>

            <th style='border:solid 1px #ccc;width:9%' id='tax_factor_th'> مالیات بر ارزش افزوده </th>
            <th style='border:solid 1px #ccc;width:9%' id='price2_factor_th'>قیمت تقریبی کل</th>
          </tr>
          <tr>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4"><span
                id='install2_factor'>{{ install2 | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' *ngIf="product==1 || product == 4"><span
                id='install1_factor'>{{ install1 | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'
              *ngIf="product==1 || product == 4 || product == 2"><span>{{ mwf2 | number
                }}</span></td>

            <td class='pishfactor-tabletr' style='border:solid 1px #ccc;'
              *ngIf="product==1 || product == 4 || product == 2"><span>{{
                price_all_without_discount_m2 | number }}</span>
            </td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc;'><span
                id='price_all_without_discount_factor'>{{ price_all_without_discount | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' [hidden]="discount_all == 0">
              <span>{{ discount_all | number }}</span>
            </td>

            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' [hidden]="discount == 0 || true"><span
                id='discount_factor'>{{ discount | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' [hidden]="discount == 0"
              *ngIf="product==1 || product == 4 || product == 2"><span id='price_all_factor'>{{ price_all1 | number
                }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' [hidden]="discount == 0"><span
                id='price_all_factor'>{{ price_all |
                number }}</span></td>


            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' id='tax_factor_td'><span id='percent_factor'>{{
                percent | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' id='price2_factor_td'><span
                id='price_final_factor'>{{ price_final | number }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc;display:none'><span
                id='price_final_factor1'></span></td>
          </tr>
        </table>

        <table class='table table2 table3 f_table1'>
          <tr class='factor-tr'>
            <td colspan=8 style='text-align:right'>مشخصات ساختمانی که شما درخواست داده اید به شرح زیر است : </td>
          </tr>
          <tr class='factor-tr'>
            <th style='border:solid 1px #ccc'> دهانه ساختمان </th>
            <th style='border:solid 1px #ccc'>نوع سقف آخر</th>
            <th style='border:solid 1px #ccc'>طراحی سازه</th>
            <th style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4 || product == 3">موقعیت
              اجرا</th>
            <th style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4">امکانات سایت</th>
            <th style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4 || product == 3">حداکثر
              دهانه بازشو</th>
            <th style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4">ارتفاع طبقات</th>
            <th style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4">محل نصب</th>
          </tr>
          <tr>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'><span>{{
                crater_title }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc;'><span>{{
                type_ceil_title }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'><span>{{ tip_title
                }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'
              *ngIf="product == 1 || product == 4 || product == 3"><span>{{ position_title
                }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4"><span
                id='site_factor'>{{ site_title }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc'
              *ngIf="product == 1 || product == 4 || product == 3"><span id='crater_factor'>{{ open_crater_title
                }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4"><span
                id='height_factor'>{{ height_title }}</span></td>
            <td class='pishfactor-tabletr' style='border:solid 1px #ccc' *ngIf="product == 1 || product == 4"><span
                id='install_place_factor'>{{ place_title }}</span></td>
          </tr>
          <tr>
            <td>آدرس پروژه : </td>
            <td colspan=12 style='padding:0px !important;text-align:right;padding:20px !important'>
              <span id='address_factor'>{{ address }}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-sm-12 col-xs-12 col-md-12 angular-with-newlines" [innerHTML]="contract">

      </div>
    </div>

    <div class="row" style="padding-top:8px;padding-right:10px;font-size: 11px;">
      <div class="pe1" *ngIf="tax_check_value == 2">
        شماره حساب رسمی: 0106411592000 بانک ملی به نام شرکت مهندسین هوشمند سازه آروین آرا
      </div>
      <div class="pe1" *ngIf="tax_check_value == 1">
        شماره حساب غیر رسمی :0107812038001 بانک ملی به نام آقای محمد ناصر زنگنه
      </div>
    </div>

    <div class='row'>
      <div class="col-md-12 pe factor-text1 prefactor-p"
        style='padding-right:20px !important;margin-top:20px;display:none'>

        <p class="pe" style='display:none;font-size:12px !important;' id='tax_text'>مالیات بر ارزش افزوده به قیمت کل
          افزوده
          خواهد می باشد. </p>
      </div>
    </div>

    <div class='row' style='direction:rtl'>
      <div class='col-md-6 pishfactor-emza'
        style='margin-top:20px !important;text-align:right !important;padding-right:22px;float:right'>
        <span style='margin-left:20px;'> امضای خریدار : </span>
        <span>....</span>
      </div>

      <div class='col-md-6 pishfactor-emza' style='margin-top:10px;display:none'>
        <span style='margin-left:20px;'> امضای فروشنده : </span>
        <span>....</span>
      </div>
    </div><!-- row -->



  </div>
</div>

<div mat-dialog-actions class="matDialogActions">
  <button class="btn" style="border:solid 1px #ccc" onclick="window.print()"> پرینت </button>
</div>